export const STAGES = [
  {
    id: "found",
    label: "Found",
    icon: "bi-bookmark",
    color: "#708090",
    description: "Jobs you saved but haven't applied to yet",
  },
  {
    id: "applied",
    label: "Applied",
    icon: "bi-send",
    color: "#36454f",
    description: "Applications you've submitted",
  },
  {
    id: "interview",
    label: "Interview",
    icon: "bi-chat-dots",
    color: "#0891b2",
    description: "In the interview process",
  },
  {
    id: "accepted",
    label: "Accepted",
    icon: "bi-trophy",
    color: "#16a34a",
    description: "Offers you received",
  },
  {
    id: "rejected",
    label: "Rejected",
    icon: "bi-x-circle",
    color: "#dc2626",
    description: "Applications that didn't work out",
  },
];

export const ACTIVE_STAGES = STAGES.filter((s) => s.id !== "rejected");

export const getStage = (id) => STAGES.find((s) => s.id === id) || STAGES[0];

// The per-job checklist. Each step points at the tab on the job page where it gets done.
export const JOB_STEPS = [
  { id: "resume", label: "Tailor your resume", tab: "resume", icon: "bi-file-earmark-person", beforeApply: true },
  { id: "coverLetter", label: "Write a cover letter", tab: "cover-letter", icon: "bi-envelope-paper", beforeApply: true },
  { id: "applied", label: "Submit the application", tab: "apply", icon: "bi-magic" },
  { id: "contacts", label: "Find people to contact", tab: "contacts", icon: "bi-person-lines-fill" },
  { id: "emailed", label: "Reach out", tab: "contacts", icon: "bi-envelope" },
];
